export default function Heading({ children }: Readonly<{children: React.ReactNode}>) {
  return (
    <div className="flex w-fit content-center items-center xl:order-last xl:mr-16 xl:w-3/12">
      <div className="flex flex-col gap-2">
        {children}
      </div>
    </div>
  )
}
